import moment from 'moment';
import Vue from "vue";

Vue.filter('diffForHumans', function (str) {
    return moment(str).from(moment());
});

Vue.filter('toISOString', function (str) {
    return moment(str).toISOString();
});

Vue.filter('formatDate', function (str, format = null, outputFormat = 'YYYY-MM-DD HH:mm:ss') {
    if (format == null) {
        return moment(str).format(outputFormat);
    }
    return moment(str, format).format(outputFormat);
});

Vue.filter('formatTimeFirst', function (str, format = null, outputFormat = 'HH:mm:ss YYYY-MM-DD') {
    if (format == null) {
        return moment(str).format(outputFormat);
    }
    return moment(str, format).format(outputFormat);
});

Vue.filter('formatDateUTCToLocal', function (str, outputFormat = 'YYYY-MM-DD HH:mm:ss') {
    return moment.utc(str).local().format(outputFormat);
});

Vue.filter('fromNow', (str, outputFormat = 'YYYY-MM-DD HH:mm:ss') => {
    return moment.utc(str, outputFormat).local().fromNow(); // moment(str, outputFormat).local().fromNow();
});

